/* global axios */

import ApiClient from './ApiClient';

class AgentPauseTemplates extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  get(agentId) {
    return axios.get(`${this.baseUrl()}/agents/${agentId}/pause_templates`);
  }

  update(agentId, pauseTemplateIds) {
    return axios.patch(`${this.baseUrl()}/agents/${agentId}/pause_templates`, {
      pause_template_ids: pauseTemplateIds,
    });
  }
}

export default new AgentPauseTemplates();
